import React from "react";
import PropTypes from "prop-types";
import "../../VehiculeForm.css";
import { vehiculeDataPropType } from "../../../../types/vehiculeTypes";

const DisplayVehiculeNeuf = ({ vehiculeData, readOnly }) => {
  return (
    <div className="form-section">
      <div className="section">
        <h3>CERTIFICATION DE CONFORMITÉ PAR LE CONSTRUCTEUR OU LE REPRÉSENTANT ACCRÉDITÉ</h3>
        <div className="radio-group">
          <label>VÉHICULE:</label>
          <div className="radio-group-child">
            <div>
              <input
                type="radio"
                name="ccv_1"
                value="0"
                checked={vehiculeData.ccv_1?.toString() === "0"}
                readOnly={readOnly}
              />
              <label>DU CONSTRUCTEUR</label>
            </div>
            <div>
              <input
                type="radio"
                name="ccv_1"
                value="1"
                checked={vehiculeData.ccv_1?.toString() === "1"}
                readOnly={readOnly}
              />
              <label>DU REPRÉSENTANT ACCRÉDITÉ</label>
            </div>
          </div>
        </div>

        <div className="form-group">
          <label>NOM ET PRÉNOM:</label>
          <input
            type="text"
            value={vehiculeData.ccs_1 || ""}
            readOnly={readOnly}
            className={readOnly ? "readonly" : ""}
          />
        </div>

        <div className="form-group">
          <label>DATE DE RÉCEPTION PAR TYPE:</label>
          <div className="date-input-group">
            <div className="date-field">
              <label>JOUR</label>
              <input
                type="text"
                value={vehiculeData.ccs_2_1 || ""}
                readOnly={readOnly}
                className={readOnly ? "readonly" : ""}
              />
            </div>
            <div className="date-field">
              <label>MOIS</label>
              <input
                type="text"
                value={vehiculeData.ccs_2_2 || ""}
                readOnly={readOnly}
                className={readOnly ? "readonly" : ""}
              />
            </div>
            <div className="date-field">
              <label>ANNÉE</label>
              <input
                type="text"
                value={vehiculeData.ccs_2_3 || ""}
                readOnly={readOnly}
                className={readOnly ? "readonly" : ""}
              />
            </div>
          </div>
        </div>

        <div className="form-group">
          <label>SOUS LE N° (K):</label>
          <input
            type="text"
            value={vehiculeData.ccs_3 || ""}
            maxLength={50}
            readOnly={readOnly}
            className={readOnly ? "readonly" : ""}
          />
        </div>
    </div>

      <div className="section">
        <h3>IDENTIFICATION DU VÉHICULE</h3>
        <div className="radio-group">
          <label>DISPOSEZ-VOUS D&apos;UN CERTIFICAT DE CONFORMITÉ EUROPÉEN (COC) SOUS FORME ÉLECTRONIQUE?</label>
          <div className="radio-group-child">
            <div>
              <input
                type="radio"
                name="veh_0"
                value="1"
                checked={vehiculeData.veh_0?.toString() === "1"}
                readOnly={readOnly}
              />
              <label>OUI</label>
            </div>
            <div>
              <input
                type="radio"
                name="veh_0"
                value="0"
                checked={vehiculeData.veh_0?.toString() === "0"}
                readOnly={readOnly}
              />
              <label>NON</label>
            </div>
          </div>
        </div>

        <div className="form-group">
          <label>MARQUE (D.1):</label>
          <input
            type="text"
            value={vehiculeData.veh_1 || ""}
            readOnly={readOnly}
            className={readOnly ? "readonly" : ""}
          />
        </div>

        <div className="form-group">
          <label>TYPE, VARIANTE, VERSION (D.2):</label>
          <input
            type="text"
            value={vehiculeData.veh_2 || ""}
            readOnly={readOnly}
            className={readOnly ? "readonly" : ""}
          />
        </div>

        <div className="form-group">
          <label>C.N.I.T (D.2.1):</label>
          <input
            type="text"
            value={vehiculeData.veh_3 || ""}
            readOnly={readOnly}
            className={readOnly ? "readonly" : ""}
          />
        </div>

        <div className="form-group">
          <label>USAGE:</label>
          <div className="radio-group-child">
            <div>
              <input
                type="radio"
                name="veh_5"
                value="1"
                checked={vehiculeData.veh_5?.toString() === "1"}
                readOnly={readOnly}
              />
              <label>OUI</label>
            </div>
            <div>
              <input
                type="radio"
                name="veh_5"
                value="0"
                checked={vehiculeData.veh_5?.toString() === "0"}
                readOnly={readOnly}
              />
              <label>NON</label>
            </div>
          </div>
        </div>

        <div className="form-group">
          <label>N° IDENTIFICATION VÉHICULE (E):</label>
          <input
            type="text"
            value={vehiculeData.veh_6 || ""}
            readOnly={readOnly}
            className={readOnly ? "readonly" : ""}
          />
        </div>

          <>
            <div className="form-group">
              <label>DÉNOMINATION COMMERCIALE (D.3):</label>
              <input
                type="text"
                value={vehiculeData.veh_4 || ""}
                readOnly={readOnly}
                className={readOnly ? "readonly" : ""}
              />
            </div>

            <div className="form-group">
              <label>MASSE EN CHARGE MAX. TECH. (F.1):</label>
              <input
                type="text"
                value={
                  vehiculeData.veh_7 !== undefined && vehiculeData.veh_7 !== null
                  ? parseInt(vehiculeData.veh_7)
                  : ""
                }
                readOnly={readOnly}
                className={readOnly ? "readonly" : ""}
              />
            </div>

            <div className="form-group">
              <label>MASSE CH. MAX. ADM. DANS L&apos;ÉTAT MEMBRE (F.2):</label>
              <input
                type="text"
                value={
                  vehiculeData.veh_8 !== undefined && vehiculeData.veh_8 !== null
                  ? parseInt(vehiculeData.veh_8)
                  : ""
                }
                readOnly={readOnly}
                className={readOnly ? "readonly" : ""}
              />
            </div>

            <div className="form-group">
              <label>MASSE EN CHARGE MAX. DE L&apos;ENSEMBLE (F.3):</label>
              <input
                type="text"
                value={
                  vehiculeData.veh_9 !== undefined && vehiculeData.veh_9 !== null
                  ? parseInt(vehiculeData.veh_9)
                  : ""
                }
                readOnly={readOnly}
                className={readOnly ? "readonly" : ""}
              />
            </div>

            <div className="form-group">
              <label>MASSE EN SERVICE (G):</label>
              <input
                type="text"
                value={
                  vehiculeData.veh_10 !== undefined && vehiculeData.veh_10 !== null
                  ? parseInt(vehiculeData.veh_10)
                  : ""
                }
                readOnly={readOnly}
                className={readOnly ? "readonly" : ""}
              />
            </div>

            <div className="form-group">
              <label>POIDS À VIDE NATIONAL (G.1):</label>
              <input
                type="text"
                value={
                  vehiculeData.veh_11 !== undefined && vehiculeData.veh_11 !== null
                  ? parseInt(vehiculeData.veh_11)
                  : ""
                }
                readOnly={readOnly}
                className={readOnly ? "readonly" : ""}
              />
            </div>

            <div className="form-group">
              <label>CATÉGORIE (J):</label>
              <input
                type="text"
                value={vehiculeData.veh_12 || ""}
                readOnly={readOnly}
                className={readOnly ? "readonly" : ""}
              />
            </div>

            <div className="form-group">
              <label>GENRE NATIONAL (J.1):</label>
              <input
                type="text"
                value={vehiculeData.veh_13 || ""}
                readOnly={readOnly}
                className={readOnly ? "readonly" : ""}
              />
            </div>

            <div className="form-group">
              <label>CARROSSERIE CE (J.2):</label>
              <input
                type="text"
                value={vehiculeData.veh_14 || ""}
                readOnly={readOnly}
                className={readOnly ? "readonly" : ""}
              />
            </div>

            <div className="form-group">
              <label>CARR. NATIONALE (J.3):</label>
              <input
                type="text"
                value={vehiculeData.veh_15 || ""}
                maxLength={10}
                readOnly={readOnly}
                className={readOnly ? "readonly" : ""}
              />
            </div>

            <div className="form-group">
              <label>CYLINDRÉE (P.1):</label>
              <input
                type="text"
                value={vehiculeData.veh_16 || ""}
                readOnly={readOnly}
                className={readOnly ? "readonly" : ""}
              />
            </div>

            <div className="form-group">
              <label>PUISS. NETTE MAXI (P.2):</label>
              <input
                type="text"
                value={vehiculeData.veh_17 || ""}
                readOnly={readOnly}
                className={readOnly ? "readonly" : ""}
              />
            </div>

            <div className="form-group">
              <label>TYPE DE CARBURANT OU SOURCE D&apos;ÉNERGIE (P.3):</label>
              <input
                type="text"
                value={vehiculeData.veh_18 || ""}
                readOnly={readOnly}
                className={readOnly ? "readonly" : ""}
              />
            </div>

            <div className="form-group">
              <label>PUISSANCE ADMINISTRATIVE NATIONALE (P.6):</label>
              <input
                type="text"
                value={vehiculeData.veh_19 || ""}
                readOnly={readOnly}
                className={readOnly ? "readonly" : ""}
              />
            </div>

            <div className="form-group">
              <label>RAPP. PUISS / MASSE (MOTORCYCLES) (Q):</label>
              <input
                type="text"
                value={vehiculeData.veh_20 || ""}
                readOnly={readOnly}
                className={readOnly ? "readonly" : ""}
              />
            </div>

            <div className="form-group">
              <label>PLACES ASSISES (S.1):</label>
              <input
                type="text"
                value={vehiculeData.veh_21 || ""}
                readOnly={readOnly}
                className={readOnly ? "readonly" : ""}
              />
            </div>

            <div className="form-group">
              <label>PLACES DEBOUT (S.2):</label>
              <input
                type="text"
                value={vehiculeData.veh_22 || ""}
                readOnly={readOnly}
                className={readOnly ? "readonly" : ""}
              />
            </div>

            <div className="form-group">
              <label>NIVEAU SONORE (U.1):</label>
              <input
                type="text"
                value={vehiculeData.veh_23 || ""}
                readOnly={readOnly}
                className={readOnly ? "readonly" : ""}
              />
            </div>

            <div className="form-group">
              <label>VITESSE DU MOTEUR (EN M-1) (U.2):</label>
              <input
                type="text"
                value={vehiculeData.veh_24 || ""}
                readOnly={readOnly}
                className={readOnly ? "readonly" : ""}
              />
            </div>

            <div className="form-group">
              <label>CO2 (EN G/KM) (V.7):</label>
              <input
                type="text"
                value={vehiculeData.veh_25 || ""}
                readOnly={readOnly}
                className={readOnly ? "readonly" : ""}
              />
            </div>

            <div className="form-group">
              <label>CLASSE ENVIRONNEMENTALE (V.9):</label>
              <input
                type="text"
                value={vehiculeData.veh_26 || ""}
                readOnly={readOnly}
                className={readOnly ? "readonly" : ""}
              />
            </div>
          </>
      </div>

      <div className="section">
        <h3>NUANCE ET COULEUR DOMINANTE</h3>
        <div className="radio-group">
          <label>NUANCE:</label>
          <div className="radio-group-child">
            <div>
              <input
                type="radio"
                name="veh_33"
                value="0"
                checked={vehiculeData.veh_33?.toString() === "0"}
                readOnly={readOnly}
              />
              <label>CLAIR</label>
            </div>
            <div>
              <input
                type="radio"
                name="veh_33"
                value="1"
                checked={vehiculeData.veh_33?.toString() === "1"}
                readOnly={readOnly}
              />
              <label>FONCÉ</label>
            </div>
          </div>
        </div>

        <div className="radio-group">
          <label>COULEUR DOMINANTE:</label>
          <div className="radio-group-child">
            <div>
              <input
                type="radio"
                name="veh_34"
                value="0"
                checked={vehiculeData.veh_34?.toString() === "0"}
                readOnly={readOnly}
              />
              <label>NOIR</label>
            </div>
            <div>
              <input
                type="radio"
                name="veh_34"
                value="1"
                checked={vehiculeData.veh_34?.toString() === "1"}
                readOnly={readOnly}
              />
              <label>MARRON</label>
            </div>
            <div>
              <input
                type="radio"
                name="veh_34"
                value="2"
                checked={vehiculeData.veh_34?.toString() === "2"}
                readOnly={readOnly}
              />
              <label>BLEU</label>
            </div>
            <div>
              <input
                type="radio"
                name="veh_34"
                value="3"
                checked={vehiculeData.veh_34?.toString() === "3"}
                readOnly={readOnly}
              />
              <label>ROUGE</label>
            </div>
            <div>
              <input
                type="radio"
                name="veh_34"
                value="4"
                checked={vehiculeData.veh_34?.toString() === "4"}
                readOnly={readOnly}
              />
              <label>BEIGE</label>
            </div>
            <div>
              <input
                type="radio"
                name="veh_34"
                value="5"
                checked={vehiculeData.veh_34?.toString() === "5"}
                readOnly={readOnly}
              />
              <label>ORANGE</label>
            </div>
            <div>
              <input
                type="radio"
                name="veh_34"
                value="6"
                checked={vehiculeData.veh_34?.toString() === "6"}
                readOnly={readOnly}
              />
              <label>GRIS</label>
            </div>
            <div>
              <input
                type="radio"
                name="veh_34"
                value="7"
                checked={vehiculeData.veh_34?.toString() === "7"}
                readOnly={readOnly}
              />
              <label>JAUNE</label>
            </div>
            <div>
              <input
                type="radio"
                name="veh_34"
                value="8"
                checked={vehiculeData.veh_34?.toString() === "8"}
                readOnly={readOnly}
              />
              <label>VERT</label>
            </div>
            <div>
              <input
                type="radio"
                name="veh_34"
                value="9"
                checked={vehiculeData.veh_34?.toString() === "9"}
                readOnly={readOnly}
              />
              <label>BLANC</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

DisplayVehiculeNeuf.propTypes = {
  vehiculeData: vehiculeDataPropType.isRequired,
  readOnly: PropTypes.bool,
};

DisplayVehiculeNeuf.defaultProps = {
  readOnly: false,
};

export default DisplayVehiculeNeuf; 